import * as React from 'react';
import { Tooltip } from '@ixicare/ui';
import { t } from '~i18n';
import { Field } from '../schema';
import { labelWithUnit } from './FieldWrapper';
import styles from '../styles.module.css';

interface Props {
  field: Field;
}

// Renders a field's label text. When the field declares a `tooltip` i18n key,
// the label text becomes a hover trigger that surfaces the tooltip.
const FieldLabel: React.FC<Props> = ({ field }) => {
  const text = labelWithUnit(field.title, field.unit);

  if (!field.tooltip) return <span className={styles.fieldLabelText}>{text}</span>;

  return (
    <span className={styles.fieldLabelText}>
      <Tooltip title={t(field.title)} content={t(field.tooltip)} hoverDelay={400} fullWidth>
        <u>{text}</u>
      </Tooltip>
    </span>
  );
};

export default FieldLabel;
